import { ProfileModalLabel } from '../label/ProfileModalLabel';

export const ModalProfileFieldWithLabel: React.FC<{
  labelContent?: string;
  childrenClassName?: string;
}> = ({ children, labelContent, childrenClassName }) => {
  return (
    <div className="flex flex-col justify-center gap-2">
      {labelContent && <ProfileModalLabel labelContent={labelContent} />}
      <div className={`${childrenClassName} flex flex-col`}>{children}</div>
    </div>
  );
};
